import { DomainLinkingStore } from "../store/useDomainLinkingStore";
import { DNS_RECORD_TYPES } from "../modules/DomainLinkingTabs/modules/DomainLinkingSetup/modules/DomainPostLinkingSetup/modules/DNSRecordsSetup/constants/DNSRecordsSetup.constants";
import { get_domain_linking_data } from "../constants/DomainLinking.urlPaths";

export const DOMAIN_DETAILS_RESOURCE_APIS = {
  domain_linking: () => {
    const { domainDetails } = DomainLinkingStore.getState();
    return {
      api_end_point: get_domain_linking_data,
      queries: {
        custom_domain_uuid: domainDetails?.uuid,
        page: 1,
        page_size: 100,
      },
    };
  },
};

export const DOMAIN_RESPONSE_APIS = {
  domain_linking: ({ listData }) => {
    const result = listData.map((obj) => ({
      id: obj.uuid,
      type: Object.keys(DNS_RECORD_TYPES).find(
        (key) => DNS_RECORD_TYPES[key] === obj.dns_record_type
      ),
      name: obj.name,
      priority: obj.priority,
      record_id: obj.record_id,
      content: obj.content,
      target: obj.metadata?.srv_data?.target,
      port: obj.metadata?.srv_data?.port,
      weight: obj.metadata?.srv_data?.weight,
    }));
    return { data: result, total: result.length };
  },
};
